import { render, staticRenderFns } from "./HasNoRateIcon.vue?vue&type=template&id=2fa891ae"
import script from "./HasNoRateIcon.vue?vue&type=script&lang=js"
export * from "./HasNoRateIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports